module.exports = __webpack_public_path__ + "static/img/1.7b20aa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/1.png
// module id = /gJN
// module chunks = 0